import {
  initializeApp,
  type FirebaseApp,
  type FirebaseOptions,
} from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

declare const __FIREBASE_API_KEY__: string | undefined;
declare const __FIREBASE_AUTH_DOMAIN__: string | undefined;
declare const __FIREBASE_PROJECT_ID__: string | undefined;
declare const __FIREBASE_APP_ID__: string | undefined;

function definedBuildValue(value: string | undefined) {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

const apiKey = definedBuildValue(
  typeof __FIREBASE_API_KEY__ !== "undefined"
    ? __FIREBASE_API_KEY__
    : undefined,
);
const authDomain = definedBuildValue(
  typeof __FIREBASE_AUTH_DOMAIN__ !== "undefined"
    ? __FIREBASE_AUTH_DOMAIN__
    : undefined,
);
const projectId = definedBuildValue(
  typeof __FIREBASE_PROJECT_ID__ !== "undefined"
    ? __FIREBASE_PROJECT_ID__
    : undefined,
);
const appId = definedBuildValue(
  typeof __FIREBASE_APP_ID__ !== "undefined" ? __FIREBASE_APP_ID__ : undefined,
);

const firebaseConfig: FirebaseOptions = {
  apiKey,
  authDomain,
  projectId,
  ...(appId ? { appId } : {}),
};

export const firebaseConfigured = Boolean(apiKey && authDomain && projectId);

let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

if (firebaseConfigured) {
  app = initializeApp(firebaseConfig);
  authInstance = getAuth(app);
}

export const auth = authInstance;
